<template>
	<div class="container">
		<div class="row">
			<div class="card">
				<div class="card-header"> 文件列表 </div>
				<ul class="list-group list-group-flush">
					<li class="list-group-item" v-for="(file, index) in fileList" :key="index">
						<a :href="'http://'+fileServer+'/files/'+file.downloadName">{{ file.displayName }}</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import UploadService from "../../httpcommon/axioInstance.js";
	
	export default{
		name: "upload-files",
		props:{
			fileList:{}
		},
		data(){
			return{
				selectedFiles: undefined,
				fileServer:global.__fileServer,
				fileInfos: [],
			}/* end @return {type} */
		},/* end data(){} */
		methods:{
			
		},/* end methods:{} */
		mounted() {
			// UploadService.getFiles().then((response) => {
			// 	this.fileInfos = response.data;
			// });
		}/* end mounted(){} */
	}/* end export */
</script>